import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PCP } from '@zipari/shared-api-models';
import { CareCardConfig } from '@zipari/shared-ds-util-care-card';

@Component({
  selector: 'lib-care-card-footer',
  templateUrl: './care-card-footer.component.html',
  styleUrls: ['./care-card-footer.component.scss'],
})
export class CareCardFooterComponent {
  @Input() config: CareCardConfig;
  @Input() instructionalText: string;
  @Input() pcp: PCP;
  @Input() providerType: string;
  @Input() textToDisplay: string; // For No PCP

  @Output() changePCPClicked: EventEmitter<null> = new EventEmitter();
}
